"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var notificationHelper = /** @class */ (function () {
    function notificationHelper() {
    }
    notificationHelper.ShowTopRightNotification = function (message, isError) {
        if (!isError) {
            antd_1.notification.open({
                message: 'Уведомление',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "exclamation-circle-o", style: { color: '#108ee9' } }),
                placement: "topRight",
            });
        }
        else {
            antd_1.notification.open({
                message: 'Ошибка',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "warning", style: { color: '#FF0000' } }),
                placement: "topRight",
            });
        }
    };
    notificationHelper.ShowTopRightNotificationText = function (message, isError) {
        if (!isError) {
            antd_1.notification.open({
                message: 'Уведомление',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "exclamation-circle-o", style: { color: '#108ee9' } }),
                placement: "topRight",
            });
        }
        else {
            antd_1.notification.open({
                message: 'Ошибка',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "warning", style: { color: '#FF0000' } }),
                placement: "topRight",
            });
        }
    };
    notificationHelper.ShowBottomRightNotificationText = function (message, isError) {
        if (!isError) {
            antd_1.notification.open({
                message: 'Уведомление',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "exclamation-circle-o", style: { color: '#108ee9' } }),
                placement: "bottomRight",
            });
        }
        else {
            antd_1.notification.open({
                message: 'Ошибка',
                description: message,
                icon: React.createElement(antd_1.Icon, { type: "warning", style: { color: '#FF0000' } }),
                placement: "bottomRight",
            });
        }
    };
    notificationHelper.ShowTextTopRightInfoNotify = function (message) {
        antd_1.notification.open({
            message: 'Уведомление',
            description: "" + message,
            icon: React.createElement(antd_1.Icon, { type: "exclamation-circle-o", style: { color: '#108ee9' } }),
            placement: "topRight",
        });
    };
    notificationHelper.ShowTextTopRightErrorNotify = function (message) {
        antd_1.notification.open({
            message: 'Ошибка',
            description: "" + message,
            icon: React.createElement(antd_1.Icon, { type: "exclamation-circle-o", style: { color: '#FF0000' } }),
            placement: "topRight",
        });
    };
    return notificationHelper;
}());
exports.default = notificationHelper;



//////////////////
// WEBPACK FOOTER
// ./src/shared/helpers/notificationHelper.tsx
// module id = 2
// module chunks = 0